import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../../lib/useApi'
import { useRealtimeRefetch } from '../../lib/realtime'
import { useCallback } from 'react'

const GOALS = [
  { key: 'wake_ok',          label: 'Wake'        },
  { key: 'training_done',    label: 'Training'    },
  { key: 'cardio_done',      label: 'Cardio'      },
  { key: 'protein_ok',       label: 'Protein'     },
  { key: 'breathing_done',   label: 'Breathing'   },
  { key: 'meditation_done',  label: 'Meditation'  },
  { key: 'no_phone_morning', label: 'No phone AM' },
  { key: 'diary_done',       label: 'Diary'       },
]

export default function DailyGoals() {
  const api = useApi()
  const qc  = useQueryClient()

  const { data: today, isLoading } = useQuery({
    queryKey: ['daily-today'],
    queryFn: () => api.get('/daily'),
  })

  const onChange = useCallback(() => qc.invalidateQueries({ queryKey: ['daily-today'] }), [qc])
  useRealtimeRefetch('daily_entries', onChange)

  function toggle(key) {
    const v = !(today?.values?.[key])
    // Optimistic: write through cache immediately, server PATCH in background
    qc.setQueryData(['daily-today'], (old) => ({
      ...(old || { values: {} }),
      values: { ...(old?.values || {}), [key]: v },
    }))
    api.put('/daily', { values: { [key]: v } })
      .then(() => {
        qc.invalidateQueries({ queryKey: ['daily-today'] })
        qc.invalidateQueries({ queryKey: ['daily-range'] })
      })
      .catch(() => { /* useApi already toasted / queued offline */ })
  }

  const values = today?.values || {}

  return (
    <section className="space-y-3">
      <div className="section-h">Heute</div>
      <div className={`grid grid-cols-2 md:grid-cols-4 gap-2 ${isLoading ? 'animate-pulse' : ''}`}>
        {GOALS.map((g) => {
          const active = !!values[g.key]
          return (
            <button key={g.key} onClick={() => toggle(g.key)}
                    className={`tap px-3 py-3 rounded-md border text-left ${
                      active
                        ? 'border-[var(--accent)] bg-[var(--accent)]/10'
                        : 'border-white/10 hover:bg-white/5'
                    }`}>
              <div className="label-mini">{g.label}</div>
              <div className={`mt-1 text-sm font-display ${active ? 'glow' : 'opacity-50'}`}>
                {active ? '✓ DONE' : '— open'}
              </div>
            </button>
          )
        })}
      </div>
    </section>
  )
}
